import usePermissions from "@/config/usePermissions";
import { Navigate } from "react-router-dom";

/**
 * DefaultRedirect - Redirects user to their first accessible route
 * Used as the index route for /admin to handle dynamic landing pages
 */
const DefaultRedirect = () => {
  const { defaultRoute, hasAnyPermissions } = usePermissions();

  // console.log("DefaultRedirect:", { defaultRoute, hasAnyPermissions });

  // If user has no permissions, show unauthorized or redirect to login
  if (!hasAnyPermissions) {
    return <Navigate to="/admin/notfound" replace />;
  }

  // Redirect to user's default accessible route
  return <Navigate to={defaultRoute} replace />;
};

export default DefaultRedirect;
